export default "__VITE_ASSET__B_9A_PRM__"